























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

@Component
export default class MasterSubject extends Vue {
  @State('selectedSubject') private stateSelectedSubject: any;
  @Mutation('setSubject') private mutationSetSubject: any;

  @Prop() private index!: number;
  @Prop() private masterSubject!: string;
  @Prop() private subSubjects!: string[];

  private showSub: boolean = false;

  @Watch('stateSelectedSubject')
  private subjectChanged() {
    if (this.subSubjects.includes(this.stateSelectedSubject)) {
      this.showSub = true;
    } else {
      this.showSub = false;
    }
  }

  private selectSubject(subjectWithSpaces: string) {
    this.$emit('hide-subjects-mobile');
    this.mutationSetSubject(subjectWithSpaces);
    const subject = subjectWithSpaces.replace(/ /g, '+');
    this.$router.push({ name: 'subject', params: { subject } });
  }

  private isSubjectselected(subject: string): boolean {
    return this.stateSelectedSubject.localeCompare(subject.replace(/\+/g, ' ')) === 0 ? true : false;
  }
}
